import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ui-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icons.component.html',
})
export class UIIconsComponent implements OnInit {
  @Input({ required: true }) name: string = '';
  @Input() size: string = 'w-[1.5rem] h-[1.25rem]';

  public link: string = '';

  ngOnInit(): void {
    this.link = `assets/icons/root.svg#${this.name}`;
  }
}
